/* import __COLOCATED_TEMPLATE__ from './estimated-time.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();